import React from 'react';
import { FileDown, FileText } from 'lucide-react';

import { DropdownMenuItem } from '@/components/ui/dropdown-menu';
import { useExportSitrep } from 'components/Reports/utils/reportsExportHelpers';
import type { GetSitrepsResponse } from 'components/Reports/reports.types';

type ReportExportMenuItemsProps = {
  sitrep: GetSitrepsResponse;
};

/** Word and PDF export for the report this kebab belongs to. */
const ReportExportMenuItems: React.FC<ReportExportMenuItemsProps> = ({
  sitrep,
}) => {
  const { exportSitrep, isExporting } = useExportSitrep();

  return (
    <>
      <DropdownMenuItem
        disabled={isExporting}
        onClick={() => {
          void exportSitrep(sitrep, 'pdf');
        }}
      >
        <FileDown />
        Export as PDF
      </DropdownMenuItem>
      <DropdownMenuItem
        disabled={isExporting}
        onClick={() => {
          void exportSitrep(sitrep, 'docx');
        }}
      >
        <FileText />
        Export as Word
      </DropdownMenuItem>
    </>
  );
};

export default ReportExportMenuItems;
